// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

const buttonSizeVariants = {
    small: {
        height: 26,
        fontSize: 12,
        weight: 700,
        letterSpacing: 0,
        lineHeight: "14px",
        padding: "0 12px",
        icon: 12,
        iconPadding: 4,
        iconMargin: 5,
    },
    medium: {
        height: 34,
        fontSize: 14,
        weight: 700,
        letterSpacing: 0,
        lineHeight: "17px",
        padding: "0 16px",
        icon: 15,
        iconPadding: 4,
        iconMargin: 4,
    },
    large: {
        height: 51,
        fontSize: 16,
        weight: 700,
        letterSpacing: 0,
        lineHeight: "19px",
        padding: "0 24px",
        icon: 20,
        iconPadding: 5,
        iconMargin: 3,
    },
};

export default buttonSizeVariants;
